import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { BlueprintsVM } from './blueprints.viewmodel';

export const BlueprintsContext = React.createContext<BlueprintsVM>(null);

export const connectedBlueprintsVM = makeConnect(BlueprintsContext);
